import React from 'react';
import MenuItem from '@/src/shared/components/HomeHeader/MenuItem/MenuItem';
import MenuDesktop from '@/src/shared/components/HomeHeader/Navigation/MenuItemDesktop';
import { menuData } from './menuData';

type Props = {
  menuClasses?: { menuItem?: string };
};

export default function DesktopNavigation({ menuClasses }: Props) {
  return (
    <>
      {menuData.map((menuItem) => {
        return (
          <MenuItem
            key={menuItem.key}
            title={menuItem.title}
            classes={menuClasses}
          >
            <MenuDesktop menuData={menuItem.data} />
          </MenuItem>
        );
      })}
    </>
  );
}
